<template>
  <span class="table-badge" :class="badgeClass">{{ displayLabel }}</span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  variant: { type: String, default: 'non_commence' },
  /** Si vide, un libellé par défaut est déduit du variant. */
  label: { type: String, default: '' },
});

const DEFAULT_LABELS = {
  non_commence: 'Non commencé',
  en_attente: 'En attente',
  entame: 'Entamé',
  termine: 'Terminé',
  erreur: 'Erreur',
  signe: 'Signé',
};

const displayLabel = computed(() => {
  if (props.label) return props.label;
  return DEFAULT_LABELS[props.variant] || props.variant || '—';
});

const badgeClass = computed(() => {
  const v = props.variant || 'non_commence';
  return {
    'table-badge--neutral': v === 'non_commence',
    'table-badge--pending': v === 'en_attente' || v === 'entame',
    'table-badge--ok': v === 'termine' || v === 'signe',
    'table-badge--danger': v === 'erreur',
  };
});
</script>

<style scoped>
.table-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.25;
  border: 1px solid transparent;
  font-family: var(--font-primary);
}

.table-badge--neutral {
  background: rgba(10, 26, 47, 0.05);
  color: rgba(10, 26, 47, 0.72);
  border-color: rgba(10, 26, 47, 0.1);
}

.table-badge--pending {
  background: rgba(212, 175, 55, 0.14);
  color: rgba(10, 26, 47, 0.86);
  border-color: rgba(212, 175, 55, 0.28);
}

.table-badge--ok {
  background: rgba(45, 134, 89, 0.12);
  color: var(--bank-success);
  border-color: rgba(45, 134, 89, 0.22);
}

.table-badge--danger {
  background: rgba(197, 48, 48, 0.1);
  color: var(--bank-danger);
  border-color: rgba(197, 48, 48, 0.22);
}
</style>
